import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { NotfoundComponent } from './notfound/notfound.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';

@NgModule({
  declarations: [
    NotfoundComponent,
    ForbiddenComponent
  ],
  imports: [
    SharedModule
  ],
})
export class ErrorModule {

}
